export default "__VITE_ASSET__BFjI1MFY__"